module.exports = __webpack_public_path__ + "NH_features_discoverable.62fe0d6c.svg";